// For customization see: https://react-select.com/styles

export const theme = (theme) => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary25: '#FFEACC',
        primary: '#FFB83A',
        primary50: '#FFD272'
    }
});

export default {
    container: (styles) => ({
        ...styles,
        width: '100%'
    }),
    control: (styles) => ({
        ...styles,
        backgroundColor: 'white',
        borderRadius: 20,
        width: '100%',
        borderColor: '#D4D4D8',
        boxShadow: '0 4px 6px -2px rgba(0, 0, 0, 0.05)'
    }),
    option: (styles, { isDisabled }) => ({
        ...styles,
        cursor: isDisabled ? 'not-allowed' : 'pointer'
    }),
    input: (styles) => ({
        ...styles,
        width: '100%',
        cursor: 'text'
    }),
    placeholder: (styles) => ({ ...styles, color: '#71717A', fontSize: '14px' }),
    multiValue: (styles) => ({
        ...styles,
        borderRadius: 20,
        paddingLeft: 5,
        backgroundColor: '#FFD272'
    }),
    multiValueLabel: (styles) => ({
        ...styles,
        color: '#414142'
    }),
    multiValueRemove: (styles) => ({
        ...styles,
        color: '#414142',
        borderTopRightRadius: 20,
        borderBottomRightRadius: 20,
        cursor: 'pointer',
        ':hover': {
            backgroundColor: '#FFB83A',
            color: 'white'
        }
    }),
    clearIndicator: (styles) => ({
        ...styles,
        cursor: 'pointer',
        ':hover': {
            color: '#FFB83A'
        }
    })
};
